import { render } from "./MyCardBody.vue?vue&type=template&id=37233c26"
import script from "./MyCardBody.vue?vue&type=script&lang=js"
export * from "./MyCardBody.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/cards/cards-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__